function autoContrast(hex: string): string {
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.5 ? '#000000' : '#ffffff';
}

export function applyThemeColors(primary?: string, contrast?: string): void {
  const isHex = (v?: string) => !!v && /^[0-9A-Fa-f]{6}$/.test(v);

  if (isHex(primary)) {
    document.documentElement.style.setProperty('--theme-primary', '#' + primary);
  }

  if (isHex(contrast)) {
    document.documentElement.style.setProperty('--theme-contrast-override', '#' + contrast);
  } else if (isHex(primary)) {
    document.documentElement.style.setProperty(
      '--theme-contrast-override',
      autoContrast(primary as string)
    );
  }
}
